import headerMixin from "@/components/shared/header/header.mixin.js";

export default {
    name: "StrideHeader",
    mixins: [headerMixin],
};
